'use client';

import { PwaBottomSheet } from '@/components/pwa-ui/PwaBottomSheet';
import { SheetDualFooter } from '@/components/pwa-ui/SheetDualFooter';
import type { PwaConfirmRequest } from '@/lib/pwa-confirm';

export function PwaConfirmSheet({
  open,
  request,
  onResolve,
}: {
  open: boolean;
  request: PwaConfirmRequest | null;
  onResolve: (ok: boolean) => void;
}) {
  const title = request?.title || 'Подтвердите действие';
  const confirmLabel = request?.confirmLabel || 'ОК';
  const cancelLabel = request?.cancelLabel || 'Отмена';
  const danger = request?.danger !== false;

  return (
    <PwaBottomSheet
      open={open && !!request}
      onClose={() => onResolve(false)}
      title={title}
      overlayClassName="z-[200]"
      footer={
        <SheetDualFooter
          layout="stack"
          primaryTone={danger ? 'terminal' : 'primary'}
          primaryLabel={confirmLabel}
          cancelLabel={cancelLabel}
          onCancel={() => onResolve(false)}
          onPrimary={() => onResolve(true)}
          primaryClassName={
            danger
              ? '!bg-red-600 !from-red-600 !to-red-700 text-white hover:opacity-95'
              : undefined
          }
        />
      }
    >
      {request?.description ? (
        <p className="px-1 pb-2 text-sm leading-relaxed text-[var(--muted-foreground)]">
          {request.description}
        </p>
      ) : (
        <div className="h-1" aria-hidden />
      )}
    </PwaBottomSheet>
  );
}
